import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from '@/components/layout/Layout';
import ErrorBoundary from '@/components/ui/ErrorBoundary';

// Lazy load pages for better performance
const Home = lazy(() => import('@/components/pages/Home'));
const Contact = lazy(() => import('@/components/pages/Contact'));
const PrivacyPolicy = lazy(() => import('@/components/pages/PrivacyPolicy'));
const DataDeletion = lazy(() => import('@/components/pages/DataDeletion'));
const TermsOfService = lazy(() => import('@/components/pages/TermsOfService'));

/**
 * Main App component with routing, error boundary, and lazy loading
 */
const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="hello" element={<Contact />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="data-deletion" element={<DataDeletion />} />
              <Route path="tos" element={<TermsOfService />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default App;
